import * as angular from 'angular';
import { PrintingService } from './printing.service';
import { ExportDialogComponent } from './export-dialog/export-dialog.component';
// import { mxPrintingMarkupDirective } from './mx-printing-markup/mx-printing-markup'; //it was not used. Should it be added?

export const printingModule = angular
	.module('mx.sb.Printing', [])
	.component(ExportDialogComponent.name, ExportDialogComponent)
	.service('mx.sb.Printing.PrintingService', PrintingService);
// .directive('mxPrintingMarkup', mxPrintingMarkupDirective);
